import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const TASKS_ENDPOINTS = {
  task: (taskId) => `${BASE_URL}api/tasks/${taskId}`,
};

export default class Task {
  eventHandlers = {};

  constructor(taskId, periodTimeCheck=250) {
    this.taskId = taskId;
    this.checkTaskStatus(periodTimeCheck);
  }

  on(eventName, callback) {
    this.eventHandlers[eventName] = callback;
  }

  checkTaskStatus = async (periodTimeCheck) => {
    let response;
    try {
      response = await request({
        url: TASKS_ENDPOINTS.task(this.taskId),
      });
    } catch (e) {
      response = { data: {} };
    }

    const { data } = response;
    if (data.status === "SUCCESS") {
      this.eventHandlers.result && this.eventHandlers.result(data.result);
    } else if (data.status === "FAILURE") {
      this.eventHandlers.error && this.eventHandlers.error(data);
    } else {
      this.eventHandlers.progress &&
        this.eventHandlers.progress({
          ...data,
          taskId: this.taskId,
          progress: data.progress || 0,
        });
      setTimeout(() => this.checkTaskStatus(periodTimeCheck), periodTimeCheck);
    }
  };
}
